<template id="view-security-params">
  <div class="container-fluid">
    <div class="row top-row">
      <div class="col-12">
        <h3>Parametros de Seguridad del Sistema</h3>
      </div>
    </div>
    <div class="row"><br /></div>
    <div class="row">
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 e-control e-lib"
      >
        <div class="card">
          <div class="card-body">
            <div class="form-group">
              <div class="row"><br /></div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-lg-3 col-md-3">
                  <label class="e-text">Días de Vigencia Contraseña</label>
                  <ejs-numerictextbox
                    id="daysDuePass"
                    format="###"
                    locale="es-CO"
                    :min="0"
                    :cssClass="hasError('daysDuePass') ? 'e-warning' : ''"
                    placeholder="Días de Vigencia"
                    v-model="m_data.daysDuePass"
                    :readonly="isFormReadOnly"
                    @input="validateField('daysDuePass')"
                    @blur="validateField('daysDuePass')"
                  ></ejs-numerictextbox>
                  <span
                    class="help e-text small"
                    :class="{ 'e-warning': hasError('daysDuePass') }"
                    v-text="m_errors.daysDuePass"
                  >
                  </span>
                </div>
                <div class="col-xs-12 col-sm-12 col-lg-3 col-md-3">
                  <label class="e-text">Cantidad Ultimas Contraseñas</label>
                  <ejs-numerictextbox
                    id="passwordSavedCount"
                    format="###"
                    locale="es-CO"
                    :min="0"
                    :cssClass="
                      hasError('passwordSavedCount') ? 'e-warning' : ''
                    "
                    placeholder="Cantidad Ultimas Contraseñas"
                    v-model="m_data.passwordSavedCount"
                    :readonly="isFormReadOnly"
                    @input="validateField('passwordSavedCount')"
                    @blur="validateField('passwordSavedCount')"
                  ></ejs-numerictextbox>
                  <span
                    class="help e-text small"
                    :class="{ 'e-warning': hasError('passwordSavedCount') }"
                    v-text="m_errors.passwordSavedCount"
                  >
                  </span>
                </div>
                <div class="col-xs-12 col-sm-12 col-lg-3 col-md-3">
                  <label class="e-text">Cantidad de Intentos Login</label>
                  <ejs-numerictextbox
                    id="attemptCountBlock"
                    format="###"
                    locale="es-CO"
                    :min="0"
                    :cssClass="hasError('attemptCountBlock') ? 'e-warning' : ''"
                    placeholder="Cantidad de Intentos Login"
                    v-model="m_data.attemptCountBlock"
                    :readonly="isFormReadOnly"
                    @input="validateField('attemptCountBlock')"
                    @blur="validateField('attemptCountBlock')"
                  ></ejs-numerictextbox>
                  <span
                    class="help e-text small"
                    :class="{ 'e-warning': hasError('attemptCountBlock') }"
                    v-text="m_errors.attemptCountBlock"
                  >
                  </span>
                </div>
                <div class="col-xs-12 col-sm-12 col-lg-3 col-md-3">
                  <label class="e-text"
                    >Desactivar Usuario por Inactividad en Días</label
                  >
                  <ejs-numerictextbox
                    id="daysInactivity"
                    format="###"
                    locale="es-CO"
                    :min="0"
                    :cssClass="hasError('daysInactivity') ? 'e-warning' : ''"
                    placeholder="Días Inactividad"
                    v-model="m_data.daysInactivity"
                    :readonly="isFormReadOnly"
                    @input="validateField('daysInactivity')"
                    @blur="validateField('daysInactivity')"
                  ></ejs-numerictextbox>
                  <span
                    class="help e-text small"
                    :class="{ 'e-warning': hasError('daysInactivity') }"
                    v-text="m_errors.daysInactivity"
                  >
                  </span>
                </div>
              </div>
              <div class="row"><br /></div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-lg-3 col-md-3">
                  <label class="e-text"
                    >Minutos para Restablecer Conteo de Intentos</label
                  >
                  <ejs-numerictextbox
                    id="minutesRestartAttempts"
                    format="###"
                    locale="es-CO"
                    :min="0"
                    :cssClass="
                      hasError('minutesRestartAttempts') ? 'e-warning' : ''
                    "
                    placeholder="Minutos Conteo Intentos"
                    v-model="m_data.minutesRestartAttempts"
                    :readonly="isFormReadOnly"
                    @input="validateField('minutesRestartAttempts')"
                    @blur="validateField('minutesRestartAttempts')"
                  ></ejs-numerictextbox>
                  <span
                    class="help e-text small"
                    :class="{
                      'e-warning': hasError('minutesRestartAttempts')
                    }"
                    v-text="m_errors.minutesRestartAttempts"
                  >
                  </span>
                </div>
                <!-- 

                  <div class="col-xs-12 col-sm-12 col-lg-3 col-md-3">
                    <label class="e-text"
                      >Intervalo en Horas para Ejecutar Desactivación
                      Automática</label
                    >
                    <ejs-numerictextbox
                      id="hoursForValidation"
                      format="###"
                      locale="es-CO"
                      :min="0"
                      :cssClass="
                        hasError('hoursForValidation') ? 'e-warning' : ''
                      "
                      placeholder="Intervalo en Horas"
                      v-model="m_data.hoursForValidation"
                      :readonly="isFormReadOnly"
                      @input="validateField('hoursForValidation')"
                      @blur="validateField('hoursForValidation')"
                    ></ejs-numerictextbox>
                    <span
                      class="help e-text small"
                      :class="{ 'e-warning': hasError('hoursForValidation') }"
                      v-text="m_errors.hoursForValidation"
                    >
                    </span>
                  </div>
                  -->
                <div class="col-xs-12 col-sm-12 col-lg-3 col-md-3">
                  <label class="e-text"
                    >Intervalo de Horas para Reestablecer contraseña</label
                  >
                  <ejs-numerictextbox
                    id="hoursForResetPass"
                    format="###"
                    locale="es-CO"
                    :min="0"
                    :cssClass="hasError('hoursForResetPass') ? 'e-warning' : ''"
                    placeholder="Intervalo en Horas"
                    v-model="m_data.hoursForResetPass"
                    :readonly="isFormReadOnly"
                    @input="validateField('hoursForResetPass')"
                    @blur="validateField('hoursForResetPass')"
                  ></ejs-numerictextbox>
                  <span
                    class="help e-text small"
                    :class="{ 'e-warning': hasError('hoursForResetPass') }"
                    v-text="m_errors.hoursForResetPass"
                  >
                  </span>
                </div>
              </div>
              <div class="row"><br /><br /></div>
              <legend style="font-size: 20px">
                Parametros de la Contraseña
              </legend>
              <hr />
              <div class="form-group">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-lg-3 col-md-3">
                    <label class="e-text">Longitud Mínima</label>
                    <ejs-numerictextbox
                      id="minLengthPass"
                      format="###"
                      locale="es-CO"
                      :min="0"
                      :cssClass="hasError('minLengthPass') ? 'e-warning' : ''"
                      placeholder="Longitud Mínima"
                      v-model="m_data.minLengthPass"
                      :readonly="isFormReadOnly"
                      @input="validateField('minLengthPass')"
                      @blur="validateField('minLengthPass')"
                    ></ejs-numerictextbox>
                    <span
                      class="help e-text small"
                      :class="{ 'e-warning': hasError('minLengthPass') }"
                      v-text="m_errors.minLengthPass"
                    >
                    </span>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-lg-3 col-md-3">
                    <label class="e-text">Longitud Máxima</label>
                    <ejs-numerictextbox
                      id="maxLengthPass"
                      format="###"
                      locale="es-CO"
                      :min="0"
                      :cssClass="hasError('maxLengthPass') ? 'e-warning' : ''"
                      placeholder="Longitud Máxima"
                      v-model="m_data.maxLengthPass"
                      :readonly="isFormReadOnly"
                      @input="validateField('maxLengthPass')"
                      @blur="validateField('maxLengthPass')"
                    ></ejs-numerictextbox>
                    <span
                      class="help e-text small"
                      :class="{ 'e-warning': hasError('maxLengthPass') }"
                      v-text="m_errors.maxLengthPass"
                    >
                    </span>
                  </div>
                </div>
                <div class="row"><br /></div>
                <div class="row">
                  <div
                    class="col-xs-12 col-sm-12 col-lg-2 col-md-2 control-section switch-control"
                  >
                    <div>
                      <ejs-switch
                        cssClass="align-middle"
                        id="reqUpperPass"
                        v-model="m_data.reqUpperPass"
                        :checked="m_data.reqUpperPass"
                        :disabled="isFormReadOnly"
                      ></ejs-switch>
                      <label
                        for="reqUpperPass"
                        class="e-text align-middle switch-label"
                        >{{
                          m_data.reqUpperPass
                            ? "Requiere Mayúsculas"
                            : "No Requiere Mayúsculas"
                        }}</label
                      >
                    </div>
                  </div>
                  <div
                    class="col-xs-12 col-sm-12 col-lg-2 col-md-2 control-section switch-control"
                  >
                    <div>
                      <ejs-switch
                        cssClass="align-middle"
                        id="reqLowerPass"
                        v-model="m_data.reqLowerPass"
                        :checked="m_data.reqLowerPass"
                        :disabled="isFormReadOnly"
                      ></ejs-switch>
                      <label
                        for="reqLowerPass"
                        class="e-text align-middle switch-label"
                        >{{
                          m_data.reqLowerPass
                            ? "Requiere Minúsculas"
                            : "No Requiere Minúsculas"
                        }}</label
                      >
                    </div>
                  </div>
                  <div
                    class="col-xs-12 col-sm-12 col-lg-2 col-md-2 control-section switch-control"
                  >
                    <div>
                      <ejs-switch
                        cssClass="align-middle"
                        id="reqNumberPass"
                        v-model="m_data.reqNumberPass"
                        :checked="m_data.reqNumberPass"
                        :disabled="isFormReadOnly"
                      ></ejs-switch>
                      <label
                        for="reqNumberPass"
                        class="e-text align-middle switch-label"
                        >{{
                          m_data.reqNumberPass
                            ? "Requiere Números"
                            : "No Requiere Números"
                        }}</label
                      >
                    </div>
                  </div>
                  <div
                    class="col-xs-12 col-sm-12 col-lg-2 col-md-2 control-section switch-control"
                  >
                    <div>
                      <ejs-switch
                        cssClass="align-middle"
                        id="reqSpecialCharacterPass"
                        v-model="m_data.reqSpecialCharacterPass"
                        :checked="m_data.reqSpecialCharacterPass"
                        :disabled="isFormReadOnly"
                      ></ejs-switch>
                      <label
                        for="reqSpecialCharacterPass"
                        class="e-text align-middle switch-label"
                        >{{
                          m_data.reqSpecialCharacterPass
                            ? "Requiere Carácteres Especiales"
                            : "No Carácteres Especiales"
                        }}</label
                      >
                    </div>
                  </div>
                  <div
                    class="col-xs-12 col-sm-12 col-lg-2 col-md-2 control-section switch-control"
                  >
                    <div>
                      <ejs-switch
                        cssClass="align-middle"
                        id="aceptSpacePass"
                        v-model="m_data.aceptSpacePass"
                        :checked="m_data.aceptSpacePass"
                        :disabled="isFormReadOnly"
                      ></ejs-switch>
                      <label
                        for="aceptSpacePass"
                        class="e-text align-middle switch-label"
                        >{{
                          m_data.aceptSpacePass
                            ? "Acepta Espacios"
                            : "No Acepta Espacios"
                        }}</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="row pull-right">
              <div class="col-xs-12 col-sm-12">
                <div class="e-btn-group">
                  <ejs-button
                    @click.native="validateForm"
                    :isPrimary="true"
                    iconCss="e-icons icon-save inline-command"
                    cssClass="e-flat e-noback"
                    v-if="showSaveButton"
                    >Grabar</ejs-button
                  >
                  <ejs-button
                    @click.native="close()"
                    iconCss="e-icons icon-cancel inline-command"
                    cssClass="e-flat e-noback"
                    >Cancelar</ejs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
/*import { object, string, number, yup, when } from "yup";*/

import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";

/* Plugins de Syncfusion */
import { Browser } from "@syncfusion/ej2-base";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { NumericTextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import { SwitchPlugin } from "@syncfusion/ej2-vue-buttons";

/* Validación con YUP*/

import * as Yup from "yup";
import { es } from "yup-locales";
import { setLocale } from "yup";
setLocale(es);

Vue.use(DialogPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(ButtonPlugin);
Vue.use(SwitchPlugin);

export default Vue.extend({
  mixins: [PermissionMixin, ToastMixin],
  computed: {
    showSaveButton() {
      if (this.isFormReadOnly) {
        return false;
      } else {
        return true;
      }
    },
    customClass() {
      return {
        "dialog-papirus": true
      };
    },
    isFormReadOnly() {
      var ret = false;

      if (this.hasPermission("CanView")) ret = true;

      if (this.hasPermission("CanCreate")) ret = false;

      if (this.hasPermission("CanEdit")) ret = false;

      return ret;
    }
  },
  data() {
    return {
      /* Datos del Componente*/
      isValid: false,
      validationSchema: {},
      m_errors: {},
      m_data: {},
      target: document.getElementById("dialog"),
      width: this.isMobile ? "500px" : "70%",
      isMobile: Browser.isDevice
    };
  },
  created() {},
  async mounted() {
    try {
      //crear el spinner de loading
      this.$parent.showLoading();
      this.buildYupSchema();
      await this.loadSecurityParams();
      this.$parent.hideLoading();
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    onDialogClose() {
      this.m_data = {};
      this.clearErrors();

      this.$emit("formClosed");
    },
    async close() {
      this.$router.push("/");
    },
    clearErrors() {
      this.m_errors = {};
    },
    async saveData() {
      try {
        this.$parent.showLoading();
        switch (this.isFormReadOnly) {
          case true:
            this.showToast(
              "No habilitado",
              "Modo consulta, nada para grabar!",
              2000
            );
            break;
          case false:
            this.m_data.regexPass = this.calulateRegex();
            await this.$store.dispatch(
              "securityParams/saveSecurityParams",
              this.m_data
            );

            this.showToast("Confirmación", "Parametros Actualizados!", 2000);
            break;
        }
        await this.loadSecurityParams();

        /* esperar medio segundo antes de cerrar */
        setTimeout(() => {
          this.$parent.hideLoading();
          this.close();
        }, 500);
      } catch (error) {
        this.$parent.hideLoading();
        this.showToast(
          "Error!",
          "Ocurrió un error al ejecutar la operación",
          2000
        );
      }
    },
    buildYupSchema() {
      /*Hack para esLint*/

      this.validationSchema = Yup.object().shape({
        daysInactivity: Yup.number()
          .required()
          .min(0)
          .typeError("Días de Inactividad")
          .label("Días Inactividad"),
        daysDuePass: Yup.number()
          .required()
          .min(0)
          .typeError("Días de Vigencia")
          .label("Días Vigencia Contraseña"),
        hoursForValidation: Yup.number()
          .required()
          .min(0)
          .typeError("Intervalo en Horas Inactivación")
          .label("Intervalo en Horas Inactivación"),
        passwordSavedCount: Yup.number()
          .required()
          .min(0)
          .typeError("Cantidad Ultimas Contraseñas")
          .label("Cantidad Ultimas Contraseñas"),
        attemptCountBlock: Yup.number()
          .required()
          .min(0)
          .typeError("Cantidad de Intentos Login")
          .label("Cantidad de Intentos Login"),
        hoursForResetPass: Yup.number()
          .required()
          .min(0)
          .typeError("Intervalo de Horas para Reestablecer contraseña")
          .label("Intervalo de Horas para Reestablecer contraseña"),
        minutesRestartAttempts: Yup.number()
          .required()
          .min(0)
          .typeError("Minutos para Restablecer Conteo de Intentos")
          .label("Minutos para Restablecer Conteo de Intentos"),
        minLengthPass: Yup.number()
          .required()
          .min(0)
          .typeError("Longitud Mínima")
          .label("Longitud Mínima")
          .lessThan(
            Yup.ref("maxLengthPass"),
            "La Longitud Mínima debe ser menor a la Máxima"
          ),
        maxLengthPass: Yup.number()
          .required()
          .min(0)
          .typeError("Longitud Máxima")
          .label("Longitud Máxima")
          .moreThan(
            Yup.ref("minLengthPass"),
            "La Longitud Máxima debe ser mayor a la Mínima"
          )
      });
    },
    hasError(field) {
      return !!this.m_errors[field];
    },
    async validateField(field) {
      Vue.set(this.m_errors, field, "");

      if (this.isFormReadOnly) return;

      this.validationSchema.validateAt(field, this.m_data).catch((err) => {
        Vue.set(this.m_errors, err.path, err.message);
      });
    },
    async validateForm() {
      this.isValid = false;
      this.m_errors = {};

      try {
        await this.validationSchema.validate(this.m_data, {
          abortEarly: false
        });

        this.m_errors = {};
        /*Grabar los datos*/

        await this.saveData();
      } catch (error) {
        error.inner.forEach((error) => {
          Vue.set(this.m_errors, error.path, error.message);
        });
      }
    },
    calulateRegex() {
      var regex = "^";

      if (this.m_data.reqUpperPass) regex = regex + "(?=.*?[A-Z])";

      if (this.m_data.reqLowerPass) regex = regex + "(?=.*?[a-z])";

      if (this.m_data.reqNumberPass) regex = regex + "(?=.*?[0-9])";

      if (this.m_data.reqSpecialCharacterPass)
        regex = regex + "(?=.*?[#?!@$%^&*+-])";

      if (this.m_data.aceptSpacePass) regex = regex + "(?=.*?[ ])";

      regex =
        regex + `.{${this.m_data.minLengthPass},${this.m_data.maxLengthPass}}$`;

      return regex;
    },
    async loadSecurityParams() {
      await this.$store.dispatch("securityParams/getSecurityParams");
      let params = this.$store.getters["securityParams/currentSecurityParams"];
      this.m_data = JSON.parse(JSON.stringify(params));
    }
  },
  props: {}
});
</script>

<style>
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../form-icons.css);

@import url(../../../node_modules/@syncfusion/ej2-vue-notifications/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-inputs/styles/fabric.css);
@import url(../../../node_modules/vue-loading-overlay/dist/vue-loading.css);

#user-dialog {
  text-align: justify;
}

.classEspecial {
  align-self: center;
}
.dialog-papirus.e-dialog .e-dlg-header {
  color: #0078d6;
  font-size: 20px;
  font-weight: normal;
}

.content-wrapper div.row {
  padding: 5px 0px;
}

.switch-label {
  padding: 0px 0px 0px 20px;
  margin: auto;
  cursor: pointer;
}

.e-save.e-icons:before,
.e-save.e-icons:before {
  content: "\e609";
}

@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }
  .e-input-section .col-xs-6,
  .e-input-section .col-xs-4,
  .e-input-section .col-xs-12 {
    padding: 10px 5px;
    width: 100%;
  }
  .content-wrapper div.row {
    padding: 0px;
  }
}
</style>
